// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__HgUAE","inputWrap":"Table_inputWrap__VFx0X","col":"Table_col__13B2F","bmiTooltip":"Table_bmiTooltip__3ziwG"};